// Registry dos painéis do envolvido. `key` casa com involved.panels.key (BD).
import RegulationPanel from './RegulationPanel.vue'
import VitalSignsPanel from './VitalSignsPanel.vue'
import IntercurrencesPanel from './IntercurrencesPanel.vue'
import AssessmentPanel from './AssessmentPanel.vue'
import ProblemsPanel from './ProblemsPanel.vue'
import NeurologicalAssessmentPanel from './NeurologicalAssessmentPanel.vue'
import PrescriptionsPanel from './PrescriptionsPanel.vue'
import DiagnosticHypothesisPanel from './DiagnosticHypothesisPanel.vue'
import EvolutionPanel from './EvolutionPanel.vue'
import OutcomePanel from './OutcomePanel.vue'
import DestinationPanel from './DestinationPanel.vue'
import NotesPanel from './NotesPanel.vue'
import CareLinePanel from './CareLinePanel.vue'
import ClassificationPanel from './ClassificationPanel.vue'

export const PANEL_COMPONENTS = {
  regulation: RegulationPanel,
  vital_signs: VitalSignsPanel,
  intercurrences: IntercurrencesPanel,
  assessment: AssessmentPanel,
  problems: ProblemsPanel,
  neurological_assessment: NeurologicalAssessmentPanel,
  prescriptions: PrescriptionsPanel,
  diagnostic_hypothesis: DiagnosticHypothesisPanel,
  destination: DestinationPanel,
  evolution: EvolutionPanel,
  outcome: OutcomePanel,
  notes: NotesPanel,
  care_line: CareLinePanel,
  classification: ClassificationPanel,
  // custom_forms NÃO entra aqui: cada formulário vira sua própria aba dinâmica,
  // expandida/renderizada diretamente por InvolvedClinicalCard.vue (ver método
  // loadCustomForms/currentCustomForm) — não é um componente único de painel.
}

// Rótulo/ícone de fallback (quando o papel não traz os painéis do BD).
// Labels são i18n keys que são resolvidas em InvolvedClinicalCard.vue com $t().
export const PANEL_META = {
  regulation: { label: 'involvedPanel.meta.regulation', icon: 'FileTextIcon' },
  care_line: { label: 'involvedPanel.meta.careLine', icon: 'HeartIcon' },
  vital_signs: { label: 'involvedPanel.meta.vitalSigns', icon: 'HeartIcon' },
  intercurrences: { label: 'involvedPanel.meta.intercurrences', icon: 'AlertTriangleIcon' },
  assessment: { label: 'involvedPanel.meta.assessment', icon: 'ClipboardIcon' },
  problems: { label: 'involvedPanel.meta.problems', icon: 'AlertCircleIcon' },
  neurological_assessment: { label: 'involvedPanel.meta.neurologicalAssessment', icon: 'ActivityIcon' },
  prescriptions: { label: 'involvedPanel.meta.prescriptions', icon: 'DropletIcon' },
  diagnostic_hypothesis: { label: 'involvedPanel.meta.diagnosticHypothesis', icon: 'CrosshairIcon' },
  destination: { label: 'involvedPanel.meta.destination', icon: 'MapPinIcon' },
  evolution: { label: 'involvedPanel.meta.evolution', icon: 'BookOpenIcon' },
  outcome: { label: 'involvedPanel.meta.outcome', icon: 'FlagIcon' },
  notes: { label: 'involvedPanel.meta.notes', icon: 'MessageSquareIcon' },
  classification: { label: 'involvedPanel.meta.classification', icon: 'FlagIcon' },
}

// Conjunto clínico completo — fallback para pessoa sem papel/painéis (legado).
// Mantém a ordem canônica das abas (ver InvolvedRoleSeeder no backend).
export const CLINICAL_FALLBACK = [
  'regulation', 'classification', 'assessment', 'vital_signs', 'problems', 'neurological_assessment', 'evolution', 'prescriptions', 'diagnostic_hypothesis', 'destination', 'intercurrences', 'outcome',
]
